export const imageCaptchaTpl = (captcha) => `
    <div id="login-form-image-captcha" class="login-form-img-captcha">
        <div class="login-form-img-captcha__wrapper">
            <div class="login-form-input-row">
                <div>
                    <input class="login-form-img-captcha__input" type="text" placeholder="点击图片刷新"/>
                </div>
            </div>
        </div>
        <div class="login-form-img-captcha-pic__wrapper">
            <div class="login-form-input-row">
                <div class="login-form-img-captcha-pic__img-wrapper">
                    <img class="login-form-img-captcha-pic__img" src="${captcha}" alt="验证码"/>
                </div>
            </div>
        </div>
    </div>
`;

const formTpl = (agreement, loginStr, defaultCheckedAgreement, title) => `
    <section class="login-form-body">
        <div class="login-form-close-btn"></div>
        <div class="login-form-title">${title}</div>
        <div class="login-form-wrapper">
            <div id="login-form-phone" class="login-form-input-row phone">
                <div>
                    <i></i>
                    <input type="text" name="phone" placeholder="电话号码">
                    <div class="login-form-phonecaptcha-btn">获取验证码</div>
                    <div class="error-msg hidden">手机号错误</div>            
                </div>
            </div>
            <div id="login-form-phone-captcha" class="login-form-input-row captcha">
                <div>
                    <i></i>
                    <input type="text" name="phonecaptcha" placeholder="手机验证码">
                    <div class="error-msg hidden">验证码错误</div>            
                    <div class="login-form-notice">未注册手机验证后自动登录</div>
                </div>
            </div>
        </div>
        <div class="login-form-submit-btn">${loginStr}</div>
        ${agreement ? ('<div class="login-form-agreement' + (defaultCheckedAgreement ? ' checked' : '') + '"><i></i><div>' + agreement + '</div></div>') : ''}
        <div class="login-toast hidden"><i class="img"></i>尚未同意协议</div>
        <div class="captcha-toast hidden"><i class="img"></i>已发送验证码</div>
    </section>
`;

export const modalTpl = (agreement, loginStr, defaultCheckedAgreement, title) => `
    <div class="login-form-modal">
        ${formTpl(agreement, loginStr, defaultCheckedAgreement, title)}
    </div>
`;

export const pageTpl = formTpl;
